import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[bulkItemHost]',
})
export class BulkItemDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
